'use strict';

import { documentReady } from "./Shared/DocumentReady";
import '../css/pages/search-results.scss';
import '../css/components/tag.scss';
import MainSearchBar from "./MainSearchBar/MainSearchBar";
import SearchAddressAutocompleteField from "./SearchAddressAutocompleteField/SearchAddressAutocompleteField";
import SearchCatTagAutocompleteField from "./SearchCatTagAutocompleteField/SearchCatTagAutocompleteField";
import MultiLocationMap from "./Map/MultiLocationMap";
import SearchResults from "./SearchResults/SearchResults";

documentReady(() => {
    window.super();
    const script = document.querySelector('script[src^="/assets/search-results.bundle.js"]');
    const where = script.getAttribute('data-where');
    const lat = script.getAttribute('data-lat');
    const lng = script.getAttribute('data-lng');
    const bbox = script.getAttribute('data-bbox');
    const what = script.getAttribute('data-what');
    const distance = script.getAttribute('data-distance');
    const paymentMethod = script.getAttribute('data-payment-method');
    const displaceMap = true;

    new SearchResults(
        new MainSearchBar(
            new SearchAddressAutocompleteField(),
            new SearchCatTagAutocompleteField()
        ),
        new MultiLocationMap(bbox, distance, displaceMap),
        lat,
        lng,
        bbox,
        what,
        where,
        distance,
        paymentMethod,
    );
});
